import { render, staticRenderFns } from "./ProjectTasksList.vue?vue&type=template&id=5595e1ec"
import script from "./ProjectTasksList.vue?vue&type=script&lang=js"
export * from "./ProjectTasksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports